import * as React from 'react';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import UserDataAccess from '../services/userDataAccess';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import PubSub from 'pubsub-js';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import IntegrationAutosuggest from './IntegrationAutosuggest';
import Switch from '@material-ui/core/Switch';
import Divider from '@material-ui/core/Divider';
import Auth from '../services/auth';
import { VIRTUA } from './constants/Accounts';
import { STORAGE_KEYS } from "../components/constants/StorageKeys";


const dataAccess = new UserDataAccess();
const auth = new Auth();

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    paper: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
    },
    paperReports: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        height: '100%',
        maxHeight: 324,
        overflow: 'auto'
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '100%',
    }
    ,
    textFieldSm: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '50%',
    },
    downRoot: {
        flexGrow: 1,
        height: 250,
    },
    downContainer: {
        flexGrow: 1,
        position: 'relative',
    },
    downPaper: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing(1),
        left: 0,
        right: 0,
    },
    downChip: {
        margin: `${theme.spacing(1) / 2}px ${theme.spacing(1) / 4}px`,
    },
    downInputRoot: {
        flexWrap: 'wrap',
    },
    downDivider: {
        height: theme.spacing(2),
    },
});


class UserDetails extends React.Component {



    constructor(props) {
        super(props);

        this.state = {
            reports: [],
            userAccounts: [],
            availableDictators: [],
            open: false,
            passwordErrors: [],
            user: {
                Id: 0,
                Account: auth.getActiveAccount(),
                AccountCreatedBy: "",
                Accounts: [],
                Active: true,
                SSOIdentity:"",
                Company: "",
                Dictators: [],
                EMail: "",
                FirstName: "",
                IsDeleted: false,
                IsDocumentWatermarked: false,
                IsVerified: false,
                LastName: "",
                Location: "",
                Maint: "",
                ModifyingUser: "",
                Password: "",
                Phone: "",
                Roles: [],
                SecArchive: false,
                SecCoding: 0,
                SecMarkRead: false,
                SecSave: false,
                SecSign: false,
                UserId: ""
            },
            openSnack: false,
            snackMessage: "",
            saveButtonDisabled: false,
        };

        let self = this;
        if (this.props.match.params.userId > 0) {
            dataAccess.getUserById(this.props.match.params.account, this.props.match.params.userId).then(
                function (userData) {
                    self.setState({ user: userData });
                    var accounts = userData.Accounts.slice(0);
                    accounts.push(userData.Account);
                    self.loadAvailableDictators(accounts);
                });
        }
        else {
            let accounts = [];
            accounts.push(this.props.match.params.account);
            self.loadAvailableDictators(accounts);
        }
    }

    loadAvailableDictators = (accounts) => {

        var self = this;
        dataAccess.getAvailableDictators(accounts).then(function (dictators) {
            self.setState({ availableDictators: dictators });
        });
    }

    handleClose = () => {
        this.setState({
            open: false,
        });
    };

    handleClick = () => {
        this.setState({
            open: true,
        });
    };

    componentWillMount() {
        this.token = PubSub.subscribe('AccountChanged', this.accountChanged.bind(this));
        const userAccounts = dataAccess.getAccounts().map((user, i) => {
            const result = Object.assign({}, user,
                {
                    Name: user.Facility,

                });

            return result;
        });


        this.setState({ userAccounts: userAccounts });
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.token);
    }
    accountChanged(msg, data) {
        this.props.history.push("/");
    }

    handlePatientChange = name => event => {

        var user = this.state.user;

        user[name] = event.target.value;

        this.setState({
            user
        });
    };

    handleCheckBoxChange = name => event => {

        var user = this.state.user;
        user[name] = event.target.checked;

        this.setState({
            user
        });

    };

    handleRoleChange = role => event => {
        var checked = event.target.checked;
        let user = this.state.user;
        let index = user.Roles.indexOf(role);
        if (checked && index === -1) {
            user.Roles.push(role);
            this.setState({ user: user });
        }
        else if (!checked && index > -1) {
            user.Roles.splice(index, 1);
            this.setState({ user: user });
        }
    }

    handleWaterMarkChange = name => event => {

        var user = this.state.user;
        user[name] = event.target.checked;

        this.setState({
            user
        });

    }


    onCancel = () => {

        this.props.history.push('/users');
    }

    onSuggestionSelected = (selectedItem) => {

        var user = this.state.user;
        user.Accounts.push(selectedItem.Account);

        this.setState({ user: user }, this.loadAvailableDictators(user.Accounts));
    }

    onDictatorSelected = (selectedItem) => {

        var user = this.state.user;
        user.Dictators.push(selectedItem);

        this.setState({ user: user });

    }
    onSaveUser = () => {
        this.setState({ saveButtonDisabled: true })
        var user = this.state.user;

        if (user.Id <= 0) {
            user.UserId = user.EMail;
        }

        var self = this;

        dataAccess.saveUser(user).then(function (rs) {
            self.setState({ user: rs, openSnack: true, snackMessage: 'User saved', passwordErrors: [], saveButtonDisabled: false });
            //console.log(rs);
            self.props.history.push(`/userDetails/${rs.Account}/${rs.Id}`);
        }).catch(error => {

            if (error.response.status === 409) {
                if (error.response.data && error.response.data.Result) {
                    self.setState({ passwordErrors: error.response.data.Result.Errors });
                }
                else if (error.response.data && error.response.data.Errors) {
                    self.setState({
                        openSnack: true, snackMessage: `Unexpected Error Saving User: ${error.response.data.Errors.join()}`
                    });
                }
                else {
                    self.setState({ openSnack: true, snackMessage: 'Unexpected Error Saving User' });
                }
            } else {
                self.setState({ openSnack: true, snackMessage: 'Unexpected Error Saving User' });
            }

        });
        

    }

    handleDelete = item => () => {

        var user = this.state.user;
        var index = user.Accounts.indexOf(item);
        if (index > -1) {
            user.Accounts.splice(index, 1);
            this.setState({ user: user });
        }

    }

    handleDeletePhysician = item => () => {

        var user = this.state.user;

        for (var i = 0; i < user.Dictators.length; i++) {
            if (user.Dictators[i].Account === item.Account &&
                user.Dictators[i].DictatorId === item.DictatorId &&
                user.Dictators[i].Shard === item.Shard) {
                user.Dictators.splice(i, 1);
                break;
            }
        }
        this.setState({ user: user });
    }

    getRelationShipOptions = () => {
        const relationships = [
            "Facility Employee",
            "Physician Office Employee",
            "Physician",
            "Management Company",
            "Coding Company",
            "Billing Company",
        ]

        if (auth.getActiveAccount() == VIRTUA) {
            relationships.push("Virtua Provider");
            relationships.push("Virtua Staff");
        }

        relationships.push("Other Vendor")
        relationships.push("Vendor")

        return (
            relationships.map(relationship => (
                <MenuItem value={relationship}>{relationship}</MenuItem>
            ))
        )
    }

    render() {

        const { classes } = this.props;
        const { openSnack, snackMessage, userAccounts, availableDictators } = this.state;
        return (
            <div style={{ paddingBottom: 250}}>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    open={openSnack}
                    autoHideDuration={3000}
                    onClose={this.handleSnackClose}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">{snackMessage}</span>}
                />
                <Grid container spacing={2}>
                    <Grid item xs={8}>
                        <Paper className={classes.paper}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Typography variant="h5">User Information</Typography>
                                    <Typography>Fill in the First and Last name, Email, and Phone fields. Use the Relationship drop down menu to select the user’s employee type. </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <TextField
                                                id="fName"
                                                label="First"
                                                className={classes.textField}
                                                margin="normal"
                                                value={this.state.user.FirstName}
                                                onChange={this.handlePatientChange('FirstName')}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                id="lName"
                                                label="Last"
                                                className={classes.textField}
                                                margin="normal"
                                                value={this.state.user.LastName}
                                                onChange={this.handlePatientChange('LastName')}
                                            />
                                        </Grid>

                                        <Grid item xs={6}>
                                            <TextField
                                                label="Email"
                                                className={classes.textField}
                                                value={this.state.user.EMail}
                                                onChange={this.handlePatientChange('EMail')}
                                                margin="normal"
                                                disabled={this.props.match.params.userId > 0 && !auth.isInRole(STORAGE_KEYS.SUPPORT_ADMIN)}
                                            />
                                        </Grid>

                                        {auth.isInRole(STORAGE_KEYS.SUPPORT_ADMIN) ? 
                                            <Grid item xs={6}>
                                                <TextField
                                                    label="Emp ID"
                                                    className={classes.textField}
                                                    value={this.state.user.UserId}
                                                    onChange={this.handlePatientChange('UserId')}
                                                    margin="normal"
                                                    disabled={!auth.isInRole(STORAGE_KEYS.SUPPORT_ADMIN)}
                                                />
                                            </Grid> : null
                                        }
                                        <Grid item xs={6}>

                                            <FormControl className={classes.formControl} fullWidth margin="normal">
                                                <InputLabel htmlFor="relationship-simple" style={{ marginLeft: '8px' }}>Relationship</InputLabel>
                                                <Select
                                                    value={this.state.user.Company}
                                                    onChange={this.handlePatientChange('Company')}
                                                    name="Company"
                                                    displayEmpty
                                                    className={classes.textField}

                                                >

                                                    {this.getRelationShipOptions()}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                label="Phone"
                                                className={classes.textField}
                                                onChange={this.handlePatientChange('Phone')}
                                                value={this.state.user.Phone}
                                                margin="normal"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                label="SSO Identity"
                                                className={classes.textField}
                                                onChange={this.handlePatientChange('SSOIdentity')}
                                                value={this.state.user.SSOIdentity}
                                                margin="normal"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <FormControlLabel style={{ margin: 8 }}
                                                control={
                                                    <Switch
                                                        checked={this.state.user.Active}
                                                        onChange={this.handleCheckBoxChange('Active')}
                                                        value="Active"
                                                    />
                                                }
                                                label={<Typography>Active Status ({this.state.user.Active && <span>Enabled</span>}{!this.state.user.Active && <span style={{ 'color': 'red' }}>Login Disabled</span>})</Typography>}
                                            />

                                        </Grid>
                                        <Grid item xs={12}>
                                            <Divider />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="h5">
                                                Roles
      </Typography>
                                            <Typography>Click the check box for the role of the user which determines what actions the user is permitted to do. You can find a short description of each role under the role names, and below is a more detailed matrix.  </Typography>

                                        </Grid>
                                        <Grid item xs={6}>
                                            <FormControl component="fieldset" className={classes.formControl}>
                                                <FormGroup>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox checked={this.state.user.Roles.indexOf('Administrator') > -1} onChange={this.handleRoleChange('Administrator')} value="Administrator" />
                                                        }
                                                        label="Administrator"
                                                    />
                                                    <Typography variant="caption">
                                                        Full Control, without E-Sign
      </Typography>

                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox checked={this.state.user.Roles.indexOf('Archivist') > -1} onChange={this.handleRoleChange('Archivist')} value="Archivist" />
                                                        }
                                                        label="Archivist"
                                                    />
                                                    <Typography variant="caption">
                                                        Archive Reports
      </Typography>

                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={this.state.user.Roles.indexOf('Editor') > -1}
                                                                onChange={this.handleRoleChange('Editor')}
                                                                value="Editor"
                                                            />
                                                        }
                                                        label="Editor"
                                                    />
                                                    <Typography variant="caption" gutterBottom>
                                                        Save and Review Reports
      </Typography>

                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={this.state.user.IsDocumentWatermarked}
                                                                onChange={this.handleWaterMarkChange('IsDocumentWatermarked')}
                                                                value="IsDocumentWatermarked"
                                                            />
                                                        }
                                                        label="Document Watermarked"
                                                    />
                                                    <Typography variant="caption" gutterBottom>
                                                        Include a watermark on reports
      </Typography>
                                                </FormGroup>


                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6}>

                                            <FormControl component="fieldset" className={classes.formControl}>

                                                <FormGroup>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox checked={this.state.user.Roles.indexOf('Signer') > -1} onChange={this.handleRoleChange('Signer')} value="Signer" />
                                                        }
                                                        label="Signer"
                                                    />
                                                    <Typography variant="caption">
                                                        E-Sign Reports
      </Typography>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox checked={this.state.user.Roles.indexOf('Viewer') > -1} onChange={this.handleRoleChange('Viewer')} value="Viewer" />
                                                        }
                                                        label="Viewer"
                                                    />
                                                    <Typography variant="caption">
                                                        View, Download, and Print Reports
      </Typography>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={this.state.user.Roles.indexOf('Coding Editor') > -1}
                                                                onChange={this.handleRoleChange('Coding Editor')}
                                                                value="Coding Editor"
                                                                disabled={!auth.isInRole('Admin')}
                                                            />
                                                        }
                                                        label="Coding Editor"
                                                    />
                                                    <Typography variant="caption">
                                                        SN Coding Access
      </Typography>
                                                </FormGroup>


                                            </FormControl>
                                        </Grid>

                                        {auth.isInRole('Admin') && <Grid item xs={12}>
                                            <Divider />
                                            <Typography variant="h5" gutterBottom>
                                                Accounts
                                                </Typography>
                                            <Grid container spacing={2}>
                                                {this.state.user.Accounts.map((column,i) => {

                                                    return (
                                                        <Grid key={i} item xs={2}>
                                                            <Chip
                                                                key={i}
                                                                label={column}
                                                                onDelete={this.handleDelete(column)}
                                                                className={classes.chip}
                                                            />
                                                        </Grid>
                                                    );
                                                }, this)}

                                            </Grid>
                                            <IntegrationAutosuggest suggestions={userAccounts} placeholder={'Add an Account'} onSuggestionSelected={this.onSuggestionSelected} clearAfterSelect={true} />


                                        </Grid>}
                                        <Grid item xs={12}>
                                            <Divider />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="h5" gutterBottom>
                                                Authorized Dictators
      </Typography>
                                            <Typography>
                                                Leaving this field blank will allow the user to access reports for all dictators set up for your facility. If the user should only have access to specific dictators, use the Add a Dictator field to search for and select those dictators one at a time. You can search by first name, last name, or dictator ID.
      </Typography>

                                            {this.state.user.Dictators.map((d,i) => {
                                                return (
                                                    <Chip
                                                        key={i}
                                                        label={`${d.Physician} - ${d.Account}-${d.DictatorId}`}
                                                        onDelete={this.handleDeletePhysician(d)}
                                                        className={classes.chip}
                                                    />
                                                );
                                            }, this)}
                                            <IntegrationAutosuggest suggestions={availableDictators} placeholder={'Add a Dictator'} onSuggestionSelected={this.onDictatorSelected} clearAfterSelect={true} />


                                        </Grid>
                                    </Grid>

                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container spacing={3} justify='flex-end'>
                                        <Grid item>
                                            <Button variant="contained" onClick={this.onCancel} color="primary">Cancel</Button>
                                        </Grid>
                                        <Grid item>
                                            <Button variant="contained" disabled={!auth.isInRole(STORAGE_KEYS.ADD_EDIT_USER) && !this.state.saveButtonDisabled} onClick={this.onSaveUser} color="primary">Save</Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                    <Grid item xs={4}>

                    </Grid>

                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(UserDetails);


// WEBPACK FOOTER //
// ./src/components/UserDetails.js